<template>
    <div>
        <common-table :table-columns="tableColumns" :form-fields="{model: []}" :url="url" :permission="{}" :operate="[]" :searchs="searchs"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "UserFunds",
        components: {CommonTable},
        data() {
            return {
                searchs:[{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                },{
                    name: 'phone',
                    placeholder: '手机号',
                    type: 'input'
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                url: {
                    get: '/userFunds/listByCondition'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    //width: '75',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }/*, {
                    field: 'wallet',
                    label: '账户',
                    show: true,
                    width: '',
                }*//*, {
                    field: 'promotion',
                    label: '活期账户',
                    show: true,
                    width: '',
                }*/, {
                    field: 'promotionAccount',
                    label: '积分',
                    show: true,
                    width: '',
                }/*, {
                    field: 'ratio',
                    label: '佣金比例',
                    show: {
                        type: 'hundredthsRatio'
                    },
                    width: '',
                }*/, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
            }
        }
    }
</script>

<style scoped>

</style>
